// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.CreateLandlordWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { CreateLandlordWebApiRequestDto, CreateLandlordWebApiResponseDto } from '../..';

export const CreateLandlordWebApiHandler_createLandlord_Path = '/api/web/v1/createLandlord';

/**
 * create landlord
 */
export const CreateLandlordWebApiHandler_createLandlord = (
  postData: CreateLandlordWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CreateLandlordWebApiRequestDto, CreateLandlordWebApiResponseDto>(
    {
      endpoint: CreateLandlordWebApiHandler_createLandlord_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
